/**
 * Tipos de documento. Fonte única: API, web, PDF, SAF-T e ficheiro AT leem
 * daqui. Ver docs/01-CONFORMIDADE-LEGAL.md §5.
 */
export const DOCUMENT_TYPES = ['PF', 'FT', 'FR', 'VD', 'NC', 'ND', 'RE', 'GR', 'GD'];
export const DOCUMENT_TYPE_META = {
    PF: { label: 'Pró-forma', fiscal: false, reportable: false, account: null, stock: null, requiresOrigin: false, requiresReason: false, paidOnIssue: false, voidable: true, hasLines: true },
    FT: { label: 'Factura', fiscal: true, reportable: true, account: 'debit', stock: 'out', requiresOrigin: false, requiresReason: false, paidOnIssue: false, voidable: false, hasLines: true },
    FR: { label: 'Factura-Recibo', fiscal: true, reportable: true, account: 'debit+credit', stock: 'out', requiresOrigin: false, requiresReason: false, paidOnIssue: true, voidable: false, hasLines: true },
    VD: { label: 'Venda a Dinheiro', fiscal: true, reportable: true, account: null, stock: 'out', requiresOrigin: false, requiresReason: false, paidOnIssue: true, voidable: false, hasLines: true },
    NC: { label: 'Nota de Crédito', fiscal: true, reportable: true, account: 'credit', stock: 'in', requiresOrigin: true, requiresReason: true, paidOnIssue: false, voidable: false, hasLines: true },
    ND: { label: 'Nota de Débito', fiscal: true, reportable: true, account: 'debit', stock: null, requiresOrigin: true, requiresReason: true, paidOnIssue: false, voidable: false, hasLines: true },
    RE: { label: 'Recibo', fiscal: true, reportable: false, account: 'credit', stock: null, requiresOrigin: false, requiresReason: false, paidOnIssue: true, voidable: true, hasLines: false },
    GR: { label: 'Guia de Remessa', fiscal: true, reportable: false, account: null, stock: 'out', requiresOrigin: false, requiresReason: false, paidOnIssue: false, voidable: false, hasLines: true },
    GD: { label: 'Guia de Devolução', fiscal: true, reportable: false, account: null, stock: 'in', requiresOrigin: true, requiresReason: true, paidOnIssue: false, voidable: false, hasLines: true },
};
/** Documentos que podem ser origem de NC/ND. */
export const CORRECTABLE_TYPES = ['FT', 'FR', 'VD'];
/** Documentos liquidáveis por Recibo. */
export const SETTLEABLE_TYPES = ['FT', 'ND'];
export const PAYMENT_METHODS = {
    NU: 'Numerário',
    TB: 'Transferência bancária',
    MP: 'M-Pesa',
    EM: 'e-Mola',
    MK: 'mKesh',
    CC: 'Cartão (POS)',
    CH: 'Cheque',
    OU: 'Outro',
};
/** Regimes de IVA do emitente (CIVA arts. 42–45 e ISPC). */
export const VAT_REGIMES = {
    normal: 'Regime normal',
    simplified: 'Regime de tributação simplificada (IVA)',
    exempt: 'Regime de isenção',
    ispc: 'ISPC — Imposto Simplificado para Pequenos Contribuintes',
};
/** Menções obrigatórias impressas conforme o regime do emitente. */
export function regimeNotice(regime) {
    switch (regime) {
        case 'simplified': return 'IVA - Não confere direito dedução'; // CIVA art. 45
        case 'exempt': return 'IVA - Regime de isenção';
        case 'ispc': return 'Contribuinte sujeito ao ISPC - IVA não liquidado';
        default: return null;
    }
}
/** Formata o número visível: "FT 2026/17". */
export function formatDocumentNumber(prefix, number) {
    return `${prefix}/${number}`;
}
/**
 * Moedas aceites nos documentos (P-01). Os totais fiscais ficam SEMPRE em MZN
 * (CIVA art. 27 n.º 5: moeda nacional); a moeda estrangeira e o câmbio do dia,
 * escrito à mão em cada documento, ficam gravados e impressos ao lado.
 */
export const CURRENCIES = {
    MZN: 'Metical', USD: 'Dólar americano', EUR: 'Euro', ZAR: 'Rand sul-africano', GBP: 'Libra esterlina', CNY: 'Yuan chinês', INR: 'Rupia indiana', AED: 'Dirham dos EAU',
};
//# sourceMappingURL=document-types.js.map